import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const toiletTrainingAge3: BlogMetaData = {
  title: '3歳のトイレトレーニング｜まだ取れないのは遅い？焦らない進め方',
  description:
    '3歳の日中のトイレトレーニングが進まず焦っていませんか？遅いと決めつけず、発達の準備・便秘や痛み・環境を確認する方法と相談目安を、モンテッソーリの視点で解説します。',
  thumbnailUrl: '/img/blog-toilet-training-age-3.webp',
  filePath: buildBlogFilePath('toilet-training-age-3'),
  category: BLOG_CATEGORY.PARENTING,
};
